import { ScheduleType } from '@/enum'
import type { IJobScheduleOptions } from '@/interfaces'
import type { ITimeBasedTrigger } from '@/interfaces/jobs/ITimeBasedTrigger'
import { DEFAULT_JOB_SCHEDULE_NUMBER_OF_OCCURRENCES } from '@/utils/constants'
import TimeBasedTrigger from './TimeBasedTrigger'

class JobScheduleOptions implements IJobScheduleOptions {
  timeBasedTrigger: ITimeBasedTrigger
  odometerReadingIncrementTrigger: number | null
  machineHoursIncrementTrigger: number | null
  numberOfOccurrences: number | null
  endAt: string | null

  constructor(scheduleOptions?: any) {
    this.timeBasedTrigger = new TimeBasedTrigger(scheduleOptions?.timeBasedTrigger)
    this.odometerReadingIncrementTrigger = scheduleOptions?.odometerReadingIncrementTrigger ?? null
    this.machineHoursIncrementTrigger = scheduleOptions?.machineHoursIncrementTrigger ?? null
    this.numberOfOccurrences =
      scheduleOptions?.numberOfOccurrences !== null &&
      scheduleOptions?.numberOfOccurrences !== undefined
        ? scheduleOptions?.numberOfOccurrences
        : !scheduleOptions?.endAt
          ? null
          : DEFAULT_JOB_SCHEDULE_NUMBER_OF_OCCURRENCES
    this.endAt = scheduleOptions?.endAt || null
  }
}

export default JobScheduleOptions
